appSocial.component('leadersSearch', {
    templateUrl: 'widgets/leaders-search/components/leaders-search/LeadersSearchComponent.html',
    bindings: {
        onClose: '&',
        onApply: '&'
    },
    controller: class LeadersSearchComponent {
        constructor(
            SocialLocaleService,
            LeadersSearchService,
            SocialConstants,
            SocialUtils,
            $timeout) {

            this.translation = SocialLocaleService.translation;
            this.$timeout = $timeout;
            /**
             * @type {LeadersSearchService}
             */
            this.searchService = LeadersSearchService;

            /**
             * @type {SocialUtils}
             */
            this.utils = SocialUtils;

            // TODO - check if we need cloneDeep here
            this.countries = _.cloneDeep(SocialConstants.countries);
            this.markets = SocialLocaleService.translateLabels(_.cloneDeep(SocialConstants.markets));
            this.dateRanges = SocialLocaleService.translateLabels(_.cloneDeep(SocialConstants.dateRanges));
            this.trades = _.cloneDeep(SocialConstants.trades);
            this.tradeSizes = _.cloneDeep(SocialConstants.tradeSizes);
            this.risks = SocialLocaleService.translateLabels(_.cloneDeep(SocialConstants.risks));

            this.searchForm = _.cloneDeep(this.searchService.search);

            this.countriesSelectConfig = {
                multiselect: true,
                id: 'code',
                label: 'country',
                showSearch: true,
                splitSelected: true,
                maxMultiSelected: 2,
                showReset: true,
            }

            this.marketsSelectConfig = {
                multiselect: true,
                id: 'id',
                label: 'label',
                showSearch: false,
                splitSelected: true,
                maxMultiSelected: 3,
                showReset: true,
            }

            this.defaultSelectConfig = {
                multiselect: false,
                id: 'id',
                label: 'label',
                showSearch: false,
                splitSelected: false,
                showReset: true,
            }

            this.order = this.searchService.order || 'desc'
        }

        setOrder(order) {
            this.order = order;
        }

        resetSearch() {
            this.searchService.reset();
            this.searchForm = _.cloneDeep(this.searchService.search);
        }

        applySearch() {
            this.searchService.search = _.cloneDeep(this.searchForm);
            this.searchService.order = this.order;
            this.searchService.updateSearch();

            // update search
            this.utils.navigate('root.app.social', {category: 'custom-search', nonce: Date.now()}, true);

            this.onClose();
        }

        close() {
            //reset non-applied search
            this.searchForm = _.cloneDeep(this.searchService.search);
            this.onClose();
        }
    }
});
